import * as ServiceContractMdls from './ServiceContractModel';
import * as CreditCardMdls from './CreditCardModel';

export interface ServiceContractRenewChargeViewModel {
    creditCardInfo: CreditCardMdls.CreditCardModel,
    error: string,
    companyCode: string,
    entityType: string,
    entityCode: string,
    arNum: string,
    amountToCharge: number,
    comments: string,
    emailForReceipt: string,
    serviceMasterNum: string,
    oldContractNum: string,
}

export const ServiceContractRenewViewModelInitialState: ServiceContractRenewChargeViewModel = {
    creditCardInfo: { ...CreditCardMdls.initialState },
    error: '',
    companyCode: '',
    entityType: '',
    entityCode: '',
    arNum: '',
    amountToCharge: 0,
    comments: '',
    emailForReceipt: '',
    serviceMasterNum: '',
    oldContractNum: ''
}

export interface ServiceContractRenewChargeScreenStatus extends CreditCardMdls.CreditCardProcess {
    amount: number,
    contractNumber: string
}


export const ServiceContractRenewChargeScreenStatusInitialLoad: ServiceContractRenewChargeScreenStatus = {
    ...CreditCardMdls.CreditCardProcessIntialState,
    amount: 0,
    contractNumber: ''
}
//Will use export interface CreditCardProcess for our screen process from CreditCardModel